export default __webpack_public_path__ + "static/media/Generic_DB.e4b200f2.svg";